var map = {
	"./About.vue": [
		"c27y",
		0,
		6
	],
	"./ApiStep.vue": [
		"ChTa",
		0,
		7
	],
	"./Apiguide.vue": [
		"MvCC",
		0,
		8
	],
	"./Checkoutcancel.vue": [
		"xLot",
		0,
		4
	],
	"./Checkoutsuccess.vue": [
		"oD3S",
		0,
		2
	],
	"./Contact.vue": [
		"FnhZ",
		0,
		20
	],
	"./Curl.vue": [
		"qV6w",
		0,
		19
	],
	"./Dashboard.vue": [
		"TGvd",
		0,
		18
	],
	"./HelloWorld.vue": [
		"gORT",
		3
	],
	"./Home.vue": [
		"lO7g",
		1,
		0
	],
	"./Javascript.vue": [
		"pIQY",
		0,
		17
	],
	"./Login.vue": [
		"xJsL",
		0,
		16
	],
	"./NotFound.vue": [
		"YcJa",
		15
	],
	"./Payment.vue": [
		"Wl27",
		0,
		14
	],
	"./Pricing.vue": [
		"Mkwv",
		0,
		13
	],
	"./Python.vue": [
		"Fy5G",
		0,
		12
	],
	"./Secure.vue": [
		"v5jq",
		11
	],
	"./Subscribe.vue": [
		"YTo8",
		0,
		10
	],
	"./Terms.vue": [
		"Rp40",
		0,
		5
	],
	"./Vox.vue": [
		"f8/i",
		9
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "mUJ2";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/components lazy ^\.\/.*\.vue$
// module id = mUJ2
// module chunks = 22